(() => {
  if (window.mpEventsReady) return;
  window.mpEventsReady = true;
  const key = 'mp_discovery_source_v1';
  const consented = () => window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
  const send = (feature, action, itemId = '', value = '') => {
    const publish = window.Shopify?.analytics?.publish;
    if (typeof publish !== 'function') return;
    try {
      Promise.resolve(window.Shopify.analytics.publish('mp_feature_interaction', {
        feature, action, item_id: String(itemId).slice(0,160), result: String(value).slice(0,80)
      })).catch(() => {});
    } catch (_) {}
  };
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const target = event.target;
    if (target.closest('[data-mp-feast-spin]')) send('roulette','start');
    else if (target.closest('[data-mp-talk-button]')) {
      const card = target.closest('[data-mp-roulette]')?.querySelector('[data-mp-feast-card]:not([hidden])');
      send('character','talk',card?.dataset.productHandle||'');
    } else if (target.closest('[data-mp-star]')) send('fortune','select_sign','',target.closest('[data-mp-star]').dataset.mpStar);
    else if (target.closest('[data-mp-quiz-options] button')) {
      const button = target.closest('button');
      send('quiz','answer','',button.classList.contains('is-correct')?'correct':'incorrect');
    } else if (target.closest('[data-mp-diagnosis] [data-mp-mood],[data-mp-diagnosis] [data-mp-scene]')) send('diagnosis','select');
    const link = target.closest('a[href]');
    if (!link) return;
    const destination = new URL(link.href,location.href);
    if (destination.origin !== location.origin) return;
    const feature = link.closest('[data-mp-roulette]')?'roulette':link.closest('[data-mp-diagnosis]')?'diagnosis':link.closest('.mp-party-photos,.mp-party-animals')?'hero':link.closest('.mood-card')?'mood':'';
    if (!feature) return;
    const itemId = destination.pathname.split('/').filter(Boolean).at(-1)||'';
    send(feature,'content_click',itemId);
    if (destination.pathname.includes('/products/') && consented()) {
      try { sessionStorage.setItem(key,JSON.stringify({feature,itemId,time:Date.now()})); } catch (_) {}
    }
  });
  document.addEventListener('mp:product-change', event => {
    const machine = event.target instanceof Element ? event.target.closest('[data-mp-roulette]') : null;
    const card = machine?.querySelector('[data-mp-feast-card]:not([hidden])');
    if (card) send('roulette','result',card.dataset.productHandle);
  },true);
  if (location.pathname.includes('/products/') && consented()) {
    try {
      const pending = JSON.parse(sessionStorage.getItem(key)||'null');
      sessionStorage.removeItem(key);
      const handle = location.pathname.split('/').filter(Boolean).at(-1);
      if (pending?.itemId===handle && Date.now()-pending.time < 600000) send(pending.feature,'product_landing',handle);
    } catch (_) {}
  }
})();
